export default __webpack_public_path__ + "static/media/landscape20.841fbf35.jpg";